document.addEventListener("DOMContentLoaded", function () {
  const detailsElements = document.querySelectorAll(".header__inline-menu details");

  detailsElements.forEach((details) => {
    details.addEventListener("toggle", function () {
      if (details.open) {
        detailsElements.forEach((otherDetails) => {
          if (otherDetails === details) return;

          // Якщо otherDetails не є ні предком, ні нащадком details - закриваємо його
          if (!details.contains(otherDetails) && !otherDetails.contains(details)) {
            otherDetails.removeAttribute("open");
          }
        });
      }
    });
  });

  window.addEventListener("scroll", function () {
    detailsElements.forEach((details) => {
      details.removeAttribute("open");
    });
  });
});
